import type { FeaturesPanelAttributes } from '../../types/cms'
import { Fragment } from 'react'
import { Container, Stack, Grid } from '@mui/material'
import {
  FeaturesSection,
  PanelGridContainer,
  PanelItem,
  FeatureList,
} from './styles'
import { MarkdownText } from 'ui-kit'

/**
 * Two-column feature cards from Features List Panel entries.
 * Multiple panels share one section so stacked zone blocks stay tight.
 */
const FeaturesListPanel = ({
  panels,
}: {
  panels?: FeaturesPanelAttributes[]
}) => {
  if (!panels?.length) return null

  return (
    <FeaturesSection>
      <Container maxWidth="xl">
        <PanelGridContainer
          container
          spacing={{ xs: 2, md: 2.5 }}
          sx={{ alignItems: 'stretch' }}
        >
          {panels.map(
            (
              {
                id,
                backgroundColour,
                textColour,
                titleLeft,
                titleRight,
                listItemsLeft,
                listItemsRight,
              },
              index,
            ) => (
              <Fragment key={id ?? `panel-${index}`}>
                <Grid item xs={12} md={6}>
                  <PanelItem
                    backgroundColor={backgroundColour}
                    textColour={textColour}
                  >
                    {titleLeft ? (
                      <MarkdownText>{titleLeft}</MarkdownText>
                    ) : null}
                    <FeatureList>
                      {listItemsLeft?.map(({ icon, info }, itemIndex) => (
                        <Stack
                          component="li"
                          direction="row"
                          alignItems="center"
                          gap={1.5}
                          key={info ?? `left-${itemIndex}`}
                        >
                          {icon?.data?.attributes?.url ? (
                            <img
                              src={icon.data.attributes.url}
                              alt={icon.data.attributes.alternativeText ?? ''}
                            />
                          ) : null}
                          {info ? <MarkdownText>{info}</MarkdownText> : null}
                        </Stack>
                      ))}
                    </FeatureList>
                  </PanelItem>
                </Grid>
                <Grid item xs={12} md={6}>
                  <PanelItem
                    backgroundColor={backgroundColour}
                    textColour={textColour}
                  >
                    {titleRight ? (
                      <MarkdownText>{titleRight}</MarkdownText>
                    ) : null}
                    <FeatureList>
                      {listItemsRight?.map(({ icon, info }, itemIndex) => (
                        <Stack
                          component="li"
                          direction="row"
                          alignItems="center"
                          gap={1.5}
                          key={info ?? `right-${itemIndex}`}
                        >
                          {icon?.data?.attributes?.url ? (
                            <img
                              src={icon.data.attributes.url}
                              alt={icon.data.attributes.alternativeText ?? ''}
                            />
                          ) : null}
                          {info ? <MarkdownText>{info}</MarkdownText> : null}
                        </Stack>
                      ))}
                    </FeatureList>
                  </PanelItem>
                </Grid>
              </Fragment>
            ),
          )}
        </PanelGridContainer>
      </Container>
    </FeaturesSection>
  )
}

export default FeaturesListPanel
